<template>
  <vs-dropdown vs-trigger-click>
    <div class="lang">
      <img :src="langUrl" alt="" class="langicon">
      <span class="">
           {{language == 'zh_CN' ? '简体中文' : 'English'}}
      </span>
      <vs-icon class="" icon="expand_more"></vs-icon>
    </div>
    <vs-dropdown-menu>
      <vs-dropdown-item>
        <div
          class="lang-item lang-item-first"
          :class="{on:language==='zh_CN'}"
          @click="handleSetLanguage('zh_CN')"
        ><img src="@/assets/images/zh_icon.png" alt="" class="lang-item-icon">简体中文</div>
      </vs-dropdown-item>
      <vs-dropdown-item>
        <div
          class="lang-item lang-item-last"
          :class="{on:language==='en_US'}"
          @click="handleSetLanguage('en_US')"
        ><img src="@/assets/images/en_icon.png" alt="" class="lang-item-icon">English</div>
      </vs-dropdown-item>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
  import zhIcon from '@/assets/images/zh_icon.png'
  import enIcon from '@/assets/images/en_icon.png'
  import Cookies from 'js-cookie';
    export default {
        name: "langSelect",
      computed: {
        langUrl() {
         
          if(this.language == 'zh_CN'){
            return zhIcon;
          }else {
            return enIcon;
          }
        }
      },
      data() {
        return {
          language:"zh_CN"
        }
      },
      created(){
          //最高优先级的语言  用户选择之后尽量保留用户习惯
        const  UserSelecLang = Cookies.get('language');
        //console.log("UserSelecLang",UserSelecLang);
        if(UserSelecLang){
          this.handleSetLanguage(UserSelecLang);
          return;
        }
        const defaultLanguage = this.getDefaultLanguage();
        //console.log("默认语言:", defaultLanguage); // 输出类似 "en-US" 或 "zh-CN"
        // 使用 switch case 判断语言类型
        switch (defaultLanguage) {
            case 'zh-CN':
                this.handleSetLanguage("zh_CN");
                break;
            case 'zh-TW':
                this.handleSetLanguage("zh_Hant");
                break;
            case 'zh-HK':
                this.handleSetLanguage("zh_Hant");
                break;
            default:
                this.handleSetLanguage("en_US");
                break;
        }




      },
      methods: {
        getDefaultLanguage(){
          // 尝试从 navigator.languages 获取首选语言
          if (navigator.languages && navigator.languages.length) {
              return navigator.languages[0];
          }
          // 否则回退到 navigator.language 或 navigator.userLanguage
          return navigator.language || navigator.userLanguage;
        },
        handleSetLanguage(lang) {//多语言
          this.$i18n.locale = lang;
          Cookies.set('language', lang,{ expires: 365 });
          this.language = lang;
          if(this.$route.name == "cashier"){
            if(lang == "zh_CN"){
              document.title = '收银台';
            }else{
              document.title = 'cashier';
            }
          }
        }
      },
    }
</script>

<style scoped>
.lang-item{
  width: 140px;
}
.langicon{
  height: 16px;
}
.lang-item-icon{
  position: relative;
  float: left;
  height: 16px;
  right: 8px;
}
.lang-item-first{
  margin: 8px 8px 0px 8px;
}
.lang-item-last{
  margin: 0px 8px 8px 8px;
}
</style>
